import moment from 'moment';
import config from '../../../config';

const readJson = async response => {
    const text = await response.text();
    const data = text ? JSON.parse(text) : null;
    if (response.ok === false || response.status >= 400 || data?.error) {
        throw new Error(data?.error || 'Unable to check overlapping jobs.');
    }
    return data;
};

export async function findPlanningOverlaps({ company, machineNo, start, end }) {
    const machine = String(machineNo || '').trim().toUpperCase();
    if (!machine) return [];
    const startTime = moment(start);
    const endTime = moment(end);
    if (!startTime.isValid() || !endTime.isValid() || !endTime.isAfter(startTime)) {
        throw new Error('Enter a valid start and end time before creating the job.');
    }
    // Read company planning independently of calendar filters. Older API versions
    // omit enclosing jobs when given date filters, so filter the full list here.
    const rows = await fetch(`${config.apiUrl}/getPlanning?company=${encodeURIComponent(company)}`)
        .then(readJson);
    if (!Array.isArray(rows)) throw new Error('Unable to read planning records.');
    const candidates = rows.filter(row => {
        if (String(row.resourceId) === '2') return false;
        const rowStart = moment(row.start);
        const rowEnd = row.start === row.end
            ? moment(row.end).endOf('day')
            : moment(row.end);
        return rowStart.isBefore(endTime) && rowEnd.isAfter(startTime);
    });
    const jobIDs = [...new Set(candidates.map(row => row.jobID))];
    const details = await Promise.all(jobIDs.map(async jobID => {
        if (!jobID) throw new Error('A conflicting planning record is missing its job sheet.');
        const response = await fetch(`${config.apiUrl}/getJobsheet?jobID=${encodeURIComponent(jobID)}`).then(readJson);
        const rows = Array.isArray(response?.data) ? response.data : response;
        const job = Array.isArray(rows) ? rows[0] : rows;
        if (!job) throw new Error('Unable to read a conflicting job sheet.');
        return [jobID, job];
    }));
    const jobs = new Map(details);
    return candidates.filter(row => String(jobs.get(row.jobID).machineNo || '').trim().toUpperCase() === machine);
}
